import type { AuthCopy } from "./auth-copy";
import { AuthForm } from "./auth-form";

export const SignUp = ({ copy, redirectTo }: { copy?: AuthCopy; redirectTo?: string } = {}) => (
  <AuthForm copy={copy} initialMode="signup" redirectTo={redirectTo} />
);
